import React, { useState, useLayoutEffect, useEffect, useContext } from "react";
import { CFormInput, CAlert, CTable, CTableDataCell, CTableHeaderCell, CTableBody, CTableRow, CTableHead, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react'
import axios from "axios";
import ReactLoading from 'react-loading';
import "../../index.css";
import { TableVirtuoso } from 'react-virtuoso';

const Usuarios = () => {
  let [loading, setLoading] = useState(true)
  const [visible1, setVisible1] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const [visible3, setVisible3] = useState(false)
  let [usersOG, setUsersOG] = useState([])
  let [users, setUsers] = useState([])
  let [tituloBoton, setTituloBoton] = useState("Suscripcion")
  const excludeColumns = ["_id", "is_active", "createdAt", "updatedAt"]; // excluye datos del arreglo donde se buscara

  function getUsers() {
    axios.get(`${process.env.REACT_APP_BackURL}/getAllUsers`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((response) => { setUsers(response.data.data); setUsersOG(response.data.data); setLoading(false) })
      .catch((err) => { console.log(err) })
  }

  // handle change event of search input
  const handleChange = (value) => {
    filterData(value)
  };

  // // filter records by search text
  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") {
      setUsers(usersOG);
    } else {
      const filteredData = usersOG.filter((item) => {
        return Object.keys(item).some((key) => {
          if (excludeColumns.includes(key)) return false;
          const val = item[key];
          if (val === null || val === undefined) return false;
          return String(val).toLowerCase().includes(lowercasedValue);
        });
      });
      setUsers(filteredData);
    }
  };

  useLayoutEffect(() => {
    getUsers()
  }, [])

  useEffect(() => {
    if (visible1) { setTimeout(() => { setVisible1(false) }, 5000); }
    if (visible2) { setTimeout(() => { setVisible2(false) }, 5000); }
    if (visible3) { setTimeout(() => { setVisible3(false) }, 5000); }
  }, [visible1, visible2, visible3])

  return (
    <>
      <div className="centro">

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', flexWrap: 'wrap', gap: '3px' }}>

          <CFormInput style={{ "width": "30%" }} type="text" id="floatingInput" label="Buscador" placeholder='Buscar' onChange={((e) => { handleChange(e.target.value) })} />

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap', gap: '3px' }}>

            <CDropdown style={{ minWidth: "200px", maxWidth: "200px" }} className='p-1'>
              <CDropdownToggle color={tituloBoton != 'Suscripción' ? "info" : "secondary"}>{tituloBoton}</CDropdownToggle>

              <CDropdownMenu className='dropdown-menu'>
                {
                  tituloBoton == 'Suscripción' ? null :
                    <CDropdownItem onClick={() => { setUsers(usersOG); setTituloBoton("Suscripción") }} style={{ color: "red" }}>Todos</CDropdownItem>
                }
                <CDropdownItem onClick={() => { setUsers(usersOG.filter(user => user.activeSubscription === true)); setTituloBoton("Activa") }} >Activas</CDropdownItem>
                <CDropdownItem onClick={() => { setUsers(usersOG.filter(user => user.activeSubscription === false)); setTituloBoton("Inactiva") }} >Inactivas</CDropdownItem>

              </CDropdownMenu>

            </CDropdown>
          </div>

          {users.length > 0 ? <h5>{users.length} Usuarios de Bebbo</h5> : <h5>No hay Usuarios</h5>}

        </div>

        {
          !loading ?
            <>

              <TableVirtuoso
                style={{ height: "70vh", width: '100%' }}
                data={users}
                components={{
                  Table: ({ style, ...props }) => <CTable {...props} style={{ backgroundColor: "rgb(82,93,113)" }} color="dark" hover />,
                  TableHead: CTableHead,
                  TableRow: CTableRow,
                  TableBody: CTableBody,
                  EmptyPlaceholder: () => (
                    <div style={{ padding: "2rem", textAlign: "center", color: "white" }}>
                      No hay usuarios registrados
                    </div>
                  ),
                }}

                fixedHeaderContent={() => (
                  <CTableRow color='info'>
                    <CTableHeaderCell style={{ minWidth: '150px' }}>Creado</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '300px' }}>Nombre</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '350px' }}>Email</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '120px' }}>Teléfono</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '50px' }}>Tipo</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '50px' }}>Suscripción</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '50px' }}>Cancela</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: '70px' }}>Gratis</CTableHeaderCell>
                  </CTableRow>
                )}

                itemContent={(index, user) => {
                  return (
                    <>
                      <CTableDataCell>{new Date(user.createdAt).toLocaleString('es-MX', { month: 'short', year: 'numeric', day: '2-digit' })}</CTableDataCell>
                      <CTableDataCell>{user.name}</CTableDataCell>
                      <CTableDataCell>{user.mail}</CTableDataCell>
                      <CTableDataCell>{user.tel}</CTableDataCell>
                      <CTableDataCell>{!user.activeSubscription ? null : user.memberType == 'solo' ? 'Solo' : user.memberType == 'owner' ? `Propietario/${user.membersCount}` : user.memberType == 'member' ? 'Miembro' : ''}</CTableDataCell>
                      <CTableDataCell>{!user.typeSubscription ? '' : user.typeSubscription}</CTableDataCell>
                      <CTableDataCell>{user.canceling ? 'Si' : ''}</CTableDataCell>
                      <CTableDataCell>{user.hadTrial ? 'Ya uso' : ''}</CTableDataCell>
                    </>
                  )
                }}
              />
            </>

            : <div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div>
        }
      </div>
    </>
  );
};

export default Usuarios;
